import { default as loadGroupActionDelegate } from 'owa-groups-shared-actions/lib/loadGroupAction';
import { onAfterNewGroupSelected } from './actions/onAfterNewGroupSelected';
import { onAfterGroupDetailsSucceeded } from './actions/onAfterGroupDetailsSucceeded';
import { groupSubscriptionStoreUpdate } from 'owa-groups-shared-store/lib/utils/groupSubscriptionStoreUpdate';
import { groupMembershipStoreUpdate } from 'owa-groups-shared-store/lib/utils/groupMembershipStoreUpdate';
import { GroupSubscriptionType } from 'owa-groups-shared-store/lib/schema/GroupSubscriptionType';

export const onAfterNewGroupSelectedAction = (groupSmtpAddress: string) => {
    onAfterNewGroupSelected(groupSmtpAddress);
};

export const onAfterGroupDetailsSucceededAction = (groupSmtpAddress: string) => {
    onAfterGroupDetailsSucceeded(groupSmtpAddress);
};

export const setGroupIsSubscribedAction = (groupSmtpAddress: string, isSubscribed: boolean) => {
    groupSubscriptionStoreUpdate(
        groupSmtpAddress,
        isSubscribed ? GroupSubscriptionType.All : GroupSubscriptionType.RepliesAndEvents
    );
};

export const setGroupIsMemberAction = (groupSmtpAddress: string, isMember: boolean) => {
    groupMembershipStoreUpdate(groupSmtpAddress, isMember);
};

export const loadGroupAction = (
    groupSmtpAddress: string,
    onLoadGroupSuccess?: () => void,
    onLoadGroupError?: () => void
) => {
    loadGroupActionDelegate(groupSmtpAddress, onLoadGroupSuccess, onLoadGroupError);
};
